/**
 * @file 开发者社区 加入社区
 * @author WanZhongYun(wanzhongyun@baidu.com)
 */
import React from 'react';
import { IJoinCommunity } from './../../types';
import { ArrowRightOutlined } from '@ant-design/icons';

import './style.less';

const DeveloperJoin: React.FC<IJoinCommunity> = props => {
    const {
        title,
        subtitle,
        openSourceCollaborationTitle,
        openSourceCollaborationList = [],
        organizationSummitListTitle,
        organizationSummitList = []
    } = props;
    return (
        <div className="developer-community-join-wrapper">
            <div className="developer-community-join-title">
                <div className="community-join-title">{title}</div>
                <div className="community-join-descript">{subtitle}</div>
            </div>
            <div className="open-source-and-cooperation">
                <div className="developer-community-sub-title">{openSourceCollaborationTitle}</div>
                <div className="cooperation-card-wrapper">
                    {
                        openSourceCollaborationList.map(item => <div className="open-source-and-cooperation-card" key={item.title}>
                            <img className='open-source-and-cooperation-icon' src={item.icon} alt="" />
                            <div className="open-source-and-cooperation-content">
                                <a className="card-target-link" href={item.link}><p className="card-title">{item.title}</p></a>
                                <p className="card-desc">{item.text}</p>
                                <a className="card-target-link" href={item.link}>
                                    <span>了解详情</span>
                                    <ArrowRightOutlined className="card-to-icon" />
                                </a>
                            </div>
                        </div>)
                    }
                </div>
            </div>
            <div className="orgination-and-summit">
                <div className="developer-community-sub-title">{organizationSummitListTitle}</div>
                <div className="summit-card-wrapper">
                    {
                        organizationSummitList.map(item => <div className="org-summit-card">
                            <a href={item.link}><img className="summit-card-png" src={item.imageUrl} alt="" /></a>
                            <div className="summit-content-wrapper">
                                <a href={item.link}><p className="summit-card-title">{item.title}</p></a>
                                <p className="summit-card-desc">{item.text}</p>
                            </div>
                        </div>)
                    }
                </div>
            </div>
        </div>
    );
};

export default DeveloperJoin;